import { toHumanReadableDate } from '@shared/services/dateService';

export const AtlSponsorRankingMapper = {
  toAtlSponsorRankingFormData: atlPreference => {
    return {
      externalUserId: atlPreference.Appraiser.ExternalUserId,
      currentRoleName: atlPreference.Appraiser.CurrentRoleName,
      name: atlPreference.Appraiser.Name,
      numOfEventsBeforeAfter: atlPreference.NumOfEventsBeforeAfter,
      assignmentRank: atlPreference.SponsorRanking?.Rank ?? null,
      eventBidDate: atlPreference.EventBid
        ? toHumanReadableDate(atlPreference.EventBid.BidDate)
        : null,
      atlAvailability: atlPreference.AtlAvailability,
      currentUserAssignmentPermissions: {
        canEditRank: true
      },
      status: null
    };
  }
};
